import { motion } from 'framer-motion';
const EmailIcon = ({ color = 'var(--pcm-accent-color)', ...props }) => (
  <motion.svg width='61' height='61' viewBox='0 0 61 61' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_0_22587)'>
      <path
        opacity='0.15'
        d='M30.1 0C46.7238 0 60.2 13.4762 60.2 30.1C60.2 46.7238 46.7238 60.2 30.1 60.2C13.4762 60.2 0 46.7238 0 30.1C0 13.4762 13.4762 0 30.1 0V0Z'
        fill={color}
      />
      <g clipPath='url(#clip1_0_22587)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M41.9671 19.6H18.2846C16.8359 19.6 15.6573 20.7498 15.6573 22.1626V22.6978L27.1859 33.9303C27.9722 34.6944 29.0176 35.1161 30.1277 35.1161C31.2397 35.1161 32.2851 34.6944 33.0695 33.9303L44.6 22.6978V22.1626C44.6 20.7498 43.4158 19.6 41.9671 19.6ZM15.6 24.4566V36.2153L21.898 30.5928L15.6 24.4566ZM44.5445 36.1811L44.5445 24.4566L38.263 30.5766L44.5445 36.1811ZM33.9428 34.7826C32.9186 35.786 31.5249 36.3485 30.0722 36.3451C28.6106 36.3451 27.234 35.7899 26.1998 34.7826L22.8305 31.4992L15.6 37.9543V39.0355C15.6 40.4502 16.7804 41.6 18.231 41.6H41.9135C43.364 41.6 44.5445 40.4502 44.5445 39.0374V37.9201L37.3306 31.483L33.9447 34.7808L33.9428 34.7826Z'
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_0_22587'>
        <rect width='60.2' height='60.2' fill='white' />
      </clipPath>
      <clipPath id='clip1_0_22587'>
        <rect width='29' height='22.0001' fill='white' transform='translate(15.6 19.6)' />
      </clipPath>
    </defs>
  </motion.svg>
);

export default EmailIcon;
